import {
  ApiRoute,
  CreateEvent,
  CreateEventSession,
  Event,
  EventCardDto,
  EventCategoryListItem,
  EventCategoryListItemSchema,
  EventHostStats,
  EventQuestionDto,
  EventQuestionDtoSchema,
  EventSchema,
  EventSession,
  EventSessionQuery,
  EventSessionSchema,
  EventSessionWithDetail,
  EventSessionWithDetailSchema,
  EventWithDetail,
  EventWithDetailSchema,
  PageData,
  PageDataSchema,
  QueryEventsReq,
  TicketTierTemplate, // TicketTierTemplateSchema,
  TicketTierType,
  UpdateEvent,
  UpdateEventStatus,
  UpsertEventQuestions,
  getApiRoute
} from "@garther/interfaces";
import { z } from "zod";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export class EventsApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.EVENT)
    });
  }

  async getCategories(): Promise<EventCategoryListItem[]> {
    return await this.get("/categories", z.array(EventCategoryListItemSchema), {
      requireAuth: false
    });
  }

  async list(options: QueryEventsReq = { limit: 6, page: 1 }): Promise<PageData<EventCardDto.Type>> {
    return await this.get("", PageDataSchema(EventCardDto.Schema), {
      params: options,
      requireAuth: false
    });
  }

  async getOne(eventId: string): Promise<EventWithDetail> {
    return await this.get(`/${eventId}`, EventWithDetailSchema, {
      requireAuth: false
    });
  }

  async createEvent(eventData: CreateEvent): Promise<Event> {
    return await this.post("", EventSchema, eventData, { requireAuth: true });
  }

  async getTicketTierTemplates(eventId: string): Promise<TicketTierTemplate[]> {
    console.log("getTicketTierTemplates", eventId);
    return [
      {
        id: "free",
        eventId: "aaa",
        title: "Free",
        description: "Free",
        type: TicketTierType.NORMAL,
        cap: 100,
        price: 10,
        minQtyPerOrder: 1,
        maxQtyPerOrder: 10,
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ];
    // return await this.get(`/${eventId}/ticket-tier-templates`, z.array(TicketTierTemplateSchema), {
    //   requireAuth: true
    // });
  }

  async getSessions(eventId: string, query: EventSessionQuery = {}): Promise<EventSessionWithDetail[]> {
    try {
      return await this.get(`/${eventId}/sessions`, z.array(EventSessionWithDetailSchema), {
        params: query,
        requireAuth: true
      });
    } catch (e) {
      console.log(20125117, e);
      return [];
    }
  }

  async createSession(eventId: string, sessionData: CreateEventSession): Promise<EventSession> {
    return await this.post(`/${eventId}/session`, EventSessionSchema, sessionData, {
      requireAuth: true
    });
  }

  async updateEvent(eventId: string, updateData: UpdateEvent): Promise<Event> {
    return await this.patch(`/${eventId}`, EventSchema, updateData, {
      requireAuth: true
    });
  }

  async updateEventStatus(eventId: string, updateData: UpdateEventStatus) {
    return await this.patch(`/${eventId}/status`, EventSchema, updateData, {
      requireAuth: true
    });
  }

  async getQuestions(eventId: string): Promise<EventQuestionDto[]> {
    return await this.get(`/${eventId}/questions`, z.array(EventQuestionDtoSchema), {
      requireAuth: false
    });
  }

  async upsertQuestions(eventId: string, data: UpsertEventQuestions): Promise<EventQuestionDto[]> {
    return await this.put(`/${eventId}/questions`, z.array(EventQuestionDtoSchema), data, {
      requireAuth: true
    });
  }

  async getHostStats(hostId: string): Promise<EventHostStats.Type> {
    return await this.get("/host-stats", EventHostStats.Schema, {
      params: { hostId },
      requireAuth: true
    });
  }

  // async deleteEvent(eventId: string): Promise<Event> {
  //   return await this.delete(`/${eventId}`, EventSchema, { requireAuth: true });
  // }
}
